import events from '../events/events';

const Timepicker = {};

/**
 * Timepicker plugin
 *
 * @param Vue
 * @param options
 */
Timepicker.install = function(Vue, options)
{
    let methods =
    {
        open(event, payload)
        {
            events.$emit('toolbox.open', 'timepicker', event, payload);
        },

        close()
        {
            events.$emit('toolbox.close');
        },
    };

    // register global methods
    Vue.timepicker = methods;

    // register instance methods
    Vue.prototype.$timepicker = methods;
};

export default Timepicker;



// WEBPACK FOOTER //
// ./src/js/plugins/timepicker.js